import React from 'react';

import { InfoTooltip } from './InfoTooltip';

const DOMAIN_EXPLANATION = [
  'These domains come from our infrastructure. They cannot be added or removed here.',
];

const EXPLANATION = [
  'Nobody with an email address on this domain can create a Choco account with a password. They have to sign up through this provider instead. Accounts that already exist keep working as they are.',
  'You can only switch this on for an email domain the provider already routes here.',
  'An email domain you switch on here keeps its setting even after the provider stops routing it, and it stays in this list. It still blocks password sign-up, so switch it off to clear it.',
];

/** Column labels for the email domain rows, shared by the read-only list and the editor. */
export const EmailDomainsTableHeader: React.FC = () => (
  <div className="flex items-center justify-between gap-4 border-b border-default-200 bg-default-100 px-4 py-2">
    <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-default-500">
      Domain
      <InfoTooltip
        label="Where these domains come from"
        paragraphs={DOMAIN_EXPLANATION}
      />
    </span>
    <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-default-500">
      Exclusive SSO login
      <InfoTooltip
        label="What exclusive SSO login means"
        paragraphs={EXPLANATION}
      />
    </span>
  </div>
);
